'use client'

// One question, answered once, shared everywhere: is this a phone-sized
// screen? Components that need JS values (sizes, item caps) read this;
// anything that can be done with a Tailwind md: prefix should be.
//
// SSR renders the desktop layout (false) and the first client paint
// corrects it, which is fine for a HUD that only exists client-side.

import { useEffect, useState } from 'react'

const QUERY = '(max-width: 767px)'

export function useIsMobile() {
  const [mobile, setMobile] = useState(false)
  useEffect(() => {
    const mq = window.matchMedia(QUERY)
    const update = () => setMobile(mq.matches)
    update()
    mq.addEventListener('change', update)
    return () => mq.removeEventListener('change', update)
  }, [])
  return mobile
}

export default useIsMobile
